import "./scss/newsletter-casa-ferrari.scss"

import { Device } from "@/utils/device"
import { Form } from "../../components/Form"
import type { WidgetAppProps, WidgetProps } from "../../types/widget.props"

export function WidgetCasaFerrari({ configuracaoSite, textosPersonalizados, device }: Readonly<WidgetProps>) {
    const isTabletMobile = (device === Device.APP || device === Device.MOBILE || device === Device.TABLET)
    const hasAllFields = (configuracaoSite.newsletterExibeNome || configuracaoSite.newsletterExibeTelefone)

    return (
        <div className="newsletter-container news-casa-ferrari flex justify-center column">
            <div className="container">
                <div className="title-ctn">
                    <h2 className="bg-title">
                        <span>{textosPersonalizados.newsletterTitle}</span>
                    </h2>
                </div>
            </div>
            <div className="container">
                <div className="newsletter flex wrap">
                    <div className="text">
                        Cadastre-se para receber promoções e novidades<br/>
                        da nossa loja diretamente em seu e-mail!
                    </div>

                    <Form
                        configuracaoSite={configuracaoSite}
                        textosPersonalizados={textosPersonalizados}
                        dinformname="newsletter-widget-casa-ferrari"
                        hasFieldTelefone
                        className={{
                            form: `flex ${isTabletMobile ? 'nowrap' :  'wrap'}${isTabletMobile && hasAllFields ? ' all-fields' : ''}`,
                        }}
                        id={{
                            nome: "news-name",
                            email: "news-mail",
                            telefone: "news-phone",
                            button: "news-subscribe"
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default class WidgetCasaFerrariApp {
    constructor(props: WidgetAppProps) {
        const el = document.getElementById(props.id)
        if (!el) return
        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(<WidgetCasaFerrari {...props} />)
    }
}

